import React from 'react'
import { FAIcon } from 'common-controls/Core/FAIcon'

export class BaseRouter extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      info: null
    }
  }

  componentDidCatch (error, info) {
    console.log('Route Error Caught', error)
    this.setState({
      hasError: true,
      error: error,
      info: info
    })
  }

  renderError () {
    const { error = {}, info } = this.state
    return <div className='text-center'>
      <h3>Error <FAIcon style={{ cursor: 'pointer' }} name='redo' onClick={() => { this.setState({ hasError: false, error: null, info: null }) }} /></h3>
      <p><b>Message</b></p>
      <p>{error.message}</p>
      <p><b>Stack Trace</b></p>
      <p>{error.stack}</p>
      <p><b>Component Trace</b></p>
      <p>{info ? info.componentStack : ''}</p>
    </div>
  }
}
